<template>
  <div v-loading="loading">
    <div class="card-option">
      <el-input
        size="large"
        placeholder="输入关键字回车搜索"
        suffix-icon="el-icon-search"
        @keyup.enter.native="handleEnter"
        v-model="pgData.title">
      </el-input>
    </div>
    <div class="card-wrap">
      <template v-if="tableData.length>0">
        <informateList
          v-for="(itemd, index) in tableData"
          :key="index"
          :data="itemd"
          detail="/yzkj/information/detail"
        ></informateList>
        <div v-if="tableData.length===8" class="lookMore" @click="lookMore">查看更多&gt;</div>
      </template>
      <template v-else>
        <div class="card-empty">暂无数据</div>
      </template>
    </div>

  </div>
</template>

<script>
import informateList from "../section/informate-list";
import utils from "@mixins/utils";

export default {
  mixins: [utils],
  components: {
    informateList,
  },
  data() {
    return {
      title: "",
      loading: false,
      tableData: [], //政策法规库
      pgData: {
        pageIndex: 1,
        pageSize: 8,
        sortOrder: "ASC",
        sourceStrs: "",
        title: "",
        informationTag: "常用",
        informationType: "",
        startTime: "",
        endTime: "",
        sortName: "",
      }
    };
  },
  methods: {
    handleEnter() {
      this.lookMore();
    },
    getData() {
      return new Promise(
        (resolve, reject) => {
          this.loading = true;
          this.$ajax({
            url: `${this.$store.state.api.baseWebUrl}/yzkj/information/search`,
            data: this.pgData,
            callback: data => {
              this.tableData = data.rows;
              resolve(data); // 成功时返回数据
            },
            error: err => {
              reject(err); // 失败时抛出错误
            },
            complete: () => {
              this.loading = false;
            }
          });
        });
    },
    //查看更多
    lookMore() {
      window.location.assign(this.pgData.title ? "/library?title=" + this.pgData.title : '/library');
    },
  },
};
</script>

<style scoped lang="scss">
.card-wrap {
  padding: 17px 20px 22px 19px;
  border-radius: 8px;
  background: #FFFFFF;
  margin-top: 16px;
  height: 324px;
}

.card-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #aaa;
  text-align: center;
  padding-top: 20px;
}

.lookMore {
  margin-top: 15px;
  text-align: center;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
</style>

